import { render, staticRenderFns } from "./DeliveryContacts.vue?vue&type=template&id=27018058&"
import script from "./DeliveryContacts.vue?vue&type=script&lang=js&"
export * from "./DeliveryContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports